module.exports = __webpack_public_path__ + "static/media/IMG_0804_Reduced.23465935.jpg";